<template>
  <div class="wrapper box  box_v">
    <page-head title="进出统计" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn">
    </page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
            <i-form ref="formInline" inline label-position="top">
              <row :gutter="80">
                <i-col span="8">
                  <FormItem label="姓名" prop="name">
                    <Input v-model="name" placeholder="请输入姓名" clearable @on-enter="initRecordList" @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="联系电话" prop="phone">
                    <Input v-model="phone" placeholder="请输入联系电话" clearable @on-enter="initRecordList"  @on-clear="initRecordList"/>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="出入类型" prop="walkType">
                    <Select v-model="walkType"  @on-change="initRecordList">
                      <Option value="in" key="in">进门</Option>
                      <Option value="out" key="out">出门</Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="时间" prop="time">
                    <DatePicker v-model="time" type="daterange" placeholder="请选择时间" @on-change="initRecordList"></DatePicker>
                  </FormItem>
                </i-col>
                <i-col span="8" v-if="isJiedao">
                  <select-community ref="community" @communityChange="communityChange"></select-community>
                </i-col>
                <i-col span="8" v-else>
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" clearable @on-change="initRecordList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
                <i-col span="8" v-if="isJiedao">
                  <FormItem label="所属小区" prop="host">
                    <Select v-model="zoneId" class="input" @on-open-change="selectZone" clearable @on-change="initRecordList">
                      <Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </row>
            </i-form>
      </Card>
      <Card dis-hover :padding="20" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <Table border :columns="settingColumn" :data="recordList" :loading="isTableLoading" @on-row-dblclick="clickRow" ></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>

  </div>
</template>

<script>
  var that
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'
  
  export default {
    name: 'walkRecord',
    components: {
      pageHead,
      selectCommunity
    },
    data () {
      return {
        btnList:[{
          name: '搜索',
          type: 'search',
          loading: false,
        }, {
          name: '重置',
          type: 'init',
          loading: false,
        },{
          name: '导出',
          type: 'export',
          loading: false,
        }],
        name:'',
        phone:'',
        communityId:0,
        time:[],
        childShequ:[],
        zoneId:'',
        zoneList:[],
        isLoadZoneList: false,
        walkType:'',
        recordList:[],
        isTableLoading:false,
        settingColumn: [
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "name"
          },
          {
            title: "身份证号",
            key: 'cardno',
            resizable: true,
          },
          {
            title: "联系电话",
            key: "phone",
            resizable: true,
          },
          {
            title: "行政区域",
            key: "communityName"
          },
          {
            title: '居住地址',
            key: 'address'
          },
          {
            title: '出入类型',
            key: 'walkType'
          },
          {
            title:'时间',
            key:'time'
          },
          {
            title:'体温',
            key:'num'
          },
          {
            title: "操作",
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.gotoDetail(params.index)
                        }
                      }
                    },
                    "[详情]"
                  ),
                ]);
            }
          },
        ],
        page:1,
        rows:6,
        total:0,
        //级联行政区域
        communityIdList:[]
      }
    },
    watch: {
      communityId(newVal) {
        //点击重置的时候 communityId变为0，此时不应获取当前社区下的微社区
        //watch 只针对当前为街道，才会发生communityId变化
        if (newVal != 0) {
          this.getZoneList(newVal)
        } else {
          this.zoneList = [];
          this.zoneId = ''
        }
      },
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      }
    },
    methods:{
       clickRow(value) {
        this.$router.push({
          name: 'fangyidetail',
          query: {
            id: value.id,
            communityId: value.communityId
          }
        })
      },
      communityChange(value){
        this.communityId = value.communityId
        this.communityIdList = value.childrenIdList
        this.initRecordList()
      },
      getRecordList () {
        var beginTime='',endTime=''
        if (this.time[0])  {
          beginTime = this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd')
          endTime = this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd')
        }
        this.$get(this.urlobj.getWalkRecord,{
          pageNum:this.page,
          pageSize:this.rows,
          zoneId:this.zoneId,
          communityIdList:this.communityIdList.length?this.communityIdList.join(','):'',
          walkType:this.walkType,
          userName:this.name,
          phoneNO:this.phone,
          beginTime,
          endTime
        }).then(res => {
          this.recordList = res.rows.map(item => {
            return {
              communityId:item.communityId,
              communityName:item.communityName,
              name:item.userName,
              cardno:item.idCardNO,
              phone:item.phoneNO,
              address:item.address,
              walkType:item.walkType == 'in'?'进门':'出门',
              num:item.temperature/100+'℃',
              time:item.createTime?this.$util.FormatDate(item.createTime,'yyyy-MM-dd HH:mm:ss'):'',
              id:item.peopleId
            }
          })
          this.total = res.total
        })
      },
      handleBtn(type) {
        if (type == 'export') {
          this.export()
        } else if (type == 'search') {
          this.initRecordList()
        }else if (type == 'init') {
          this.name = ''
          this.phone = ''
          this.walkType = ''
          this.zoneId = ''
          this.communityId = 0
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community.selectCommunity="");
          this.initRecordList()
        }
      },
      export () {
        var beginTime='',endTime=''
        if (this.time[0])  {
          beginTime = this.time[0]?this.$util.FormatDate(new Date(this.time[0]),'yyyy-MM-dd'):""
          endTime = this.time[1]?this.$util.FormatDate(new Date(this.time[1]),'yyyy-MM-dd'):''
        }
        let url = this.urlobj.exportWalkReport
          + '?zoneId='
          + (this.zoneId? this.zoneId: "")
          + '&communityIdList='
          + (this.communityId?this.communityId:'')
          + '&walkType='
          + (this.walkType? this.walkType: "")
          + '&userName='
          + (this.name? this.name: "")
          + '&phoneNO='
          + (this.phone? this.phone: "")
          + '&token='
          + this.$store.state.access_token
          + '&beginTime='
          +  beginTime
          + '&endTime='
          + endTime
        console.log(url)
        window.open(url)
      },
      initRecordList () {
        this.page = 1
        this.getRecordList()
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }
        }
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var item = {
            name: '全部',
            id: 0,
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item)
          this.childShequ = list
        });
      },
      //获取微社区列表
      getZoneList(id) {
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        this.$get(url, {
          communityId: id,
          zoneType:1,
          hasChild:1
        }).then(res => {
          this.isLoadZoneList = false
          this.zoneList = res.rows
          this.zoneList.push({
            zoneId:0,
            zoneName:'其他'
          })
        }).catch(e => {
          this.isLoadZoneList = false;
          console.log(e)
        })
      },
      gotoDetail (index) {
        var id = this.recordList[index].id,
          communityId = this.recordList[index].communityId
        this.$router.push({
          name: 'fangyidetail',
          query: {id, communityId}
        })
      },
      pageChange(val) {
        this.page = val;
        this.getRecordList();
      },
    },
    mounted () {
      that = this
      console.log(this.$store.state.isJiedao)
      if (parseInt(this.$store.state.isJiedao)) {
        console.log('11111')
        this.getChildShequ();
      } else {
        console.log('222222')
        this.getZoneList(this.$store.state.streetorcommunityid)
      }
      this.getRecordList()
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  /deep/ .ivu-table-tip {
    overflow-x: hidden;
  }
  .wrapper {
    height: 100%;
  }
  .card-box {
    margin: 0 20px 20px;
  }
  .table-card {
    padding: 20px 0px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }
  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
